"use strict";

module.exports.installmentLocales = ['pt_BR', 'ja_JP', 'tr_TR', 'es_MX'];